import { Flex } from '../Flex/';
import { Text } from '../Text/';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SlotFlexContainer = ({
  children,
  justifyContent,
  columnGap = '0'
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    columnGap: columnGap,
    flex: "1 1 0%",
    justifyContent: justifyContent,
    children: children
  });
};
const OuterContainer = styled.div.withConfig({
  displayName: "EditorToolbar__OuterContainer",
  componentId: "snjvw3-0"
})(["background-color:#253342;"]);
export const EditorToolbar = ({
  startSlot,
  endSlot,
  title
}) => {
  return /*#__PURE__*/_jsx(OuterContainer, {
    role: "toolbar",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      columnGap: "300",
      flexWrap: "nowrap",
      flexShrink: 0,
      justifyContent: "center",
      paddingBlock: "200",
      paddingInlineStart: "800",
      paddingInlineEnd: "500",
      children: [/*#__PURE__*/_jsx(SlotFlexContainer, {
        justifyContent: "start",
        columnGap: "300",
        children: startSlot
      }), /*#__PURE__*/_jsx(SlotFlexContainer, {
        justifyContent: "center",
        children: typeof title === 'string' ? /*#__PURE__*/_jsx(Text, {
          as: "h4",
          color: "text-primary-on-fill-default",
          truncate: true,
          wordBreak: "keep-all",
          children: title
        }) : title
      }), /*#__PURE__*/_jsx(SlotFlexContainer, {
        justifyContent: "end",
        columnGap: "300",
        children: endSlot
      })]
    })
  });
};